import { CurrencyCircleDollarIcon, MapPinIcon, UserIcon, UsersIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { formatMoney } from '@/helpers/helpers'

import { AttendeeAvatarList } from './AttendeeAvatarList'
import { BasicInfo } from './BasicInfo'

interface BasicInfoSectionProps {
  eventType: string
  organizer?: string
  place?: string
  hideAttendees?: boolean
  price?: string
  advancedTicketingEnabled?: boolean
}

export const BasicInfoSection = ({
  eventType,
  organizer,
  place,
  hideAttendees,
  price,
  advancedTicketingEnabled = false,
}: BasicInfoSectionProps) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className="basic-info-section">
      <div className="divider" />
      {['Appointment', 'Class', 'Event'].includes(eventType) && (
        <BasicInfo icon={<UserIcon />}>
          <p>{organizer || t('eventManagement:common.eventTypeFacilitator', { eventType })}</p>
        </BasicInfo>
      )}
      <div className="divider" />
      <BasicInfo icon={<MapPinIcon />}>
        <p>{place || t('eventManagement:common.location')}</p>
      </BasicInfo>

      {!advancedTicketingEnabled && (
        <>
          <div className="divider" />
          <BasicInfo icon={<CurrencyCircleDollarIcon />}>
            <p>{Number(price) ? formatMoney(price) : 'Free'}</p>
          </BasicInfo>
        </>
      )}

      {!hideAttendees && (
        <>
          <div className="divider" />
          <BasicInfo icon={<UsersIcon />}>
            <AttendeeAvatarList />
          </BasicInfo>
        </>
      )}

      <div className="divider" />
    </div>
  )
}
